(() => {
  const init = section => {
    if (section.dataset.careTabsReady) return;
    section.dataset.careTabsReady = 'true';
    const tabs = [...section.querySelectorAll('[data-care-tab]')];
    const cells = [...section.querySelectorAll('[data-care-group]')];
    const panel = section.querySelector('[role="tabpanel"]');
    const rail = section.querySelector('[data-paw-best-rail]');
    if (!tabs.length || !panel) return;
    const select = tab => {
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      cells.forEach(cell => { cell.hidden = cell.dataset.careGroup !== tab.dataset.careTab; });
      panel.setAttribute('aria-labelledby', tab.id);
      if (rail) {
        rail.scrollLeft = 0;
        requestAnimationFrame(() => rail.dispatchEvent(new Event('scroll')));
      }
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
        else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        if (!next) return;
        event.preventDefault();
        select(next);
        next.focus();
      });
    });
    select(tabs[0]);
  };
  document.querySelectorAll('[data-paw-care-tabs]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches?.('[data-paw-care-tabs]')) init(event.target);
    event.target.querySelectorAll?.('[data-paw-care-tabs]').forEach(init);
  });
})();

